export default __webpack_public_path__ + "static/media/logo-independency.fff4a6d4.png";